



































































































import {AccountTypeEnum, NeedModel, PartyModel, PartyNeedGroupModel, PartyNeedModel, TenantUserModel} from '@/libs/Api';
import {Guid} from '@/libs/common/functions/guid';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {needsStore} from '@/libs/needs/+state/store';
import {partyNeedGroupsStore} from '@/libs/party-need-groups/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import {Component, Prop, Ref} from 'vue-property-decorator';
import {partiesStore} from '../+state/store';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';

@Component({})
export default class PartyNeeds extends Page {

    partyNeedGroup: PartyNeedGroupModel | null = null;
    partyNeeds: PartyNeedModel[] = [];
    saving = false;
    editMode = false;
    valid = false;
    basicRules = [
        (v: any) => !!v || this.$t('validation.thisFieldIsRequired')
    ];

    itemToDelete: PartyNeedGroupModel | null = null;
    deleteDialog = false;
    deleting = false;

    /* Auth variables */
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    @Ref() form!: any;

    get party(): PartyModel {
        return {...partiesStore.useGetter(CrudGetter.Detail)} as PartyModel;
    }

    get partyNeedGroups (): PartyNeedModel[] {
        return [...partyNeedGroupsStore.useGetter(CrudGetter.Data)];
    }

    get needs (): NeedModel[] {
        return [...needsStore.useGetter(CrudGetter.Data)];
    }

    get loading(): boolean {
        return needsStore.useGetter(CrudGetter.Pending);
    }

    get printing(): boolean {
        return partyNeedGroupsStore.useGetter(CrudGetter.Printing);
    }

    mounted () {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
            this.$router.replace({
                name: "PartyGeneral",
                params: {
                    tenantId: this.$router.currentRoute.params.tenantId,
                    partyId: this.$router.currentRoute.params.partyId,
                }
            })
        }
        else {
            this.loadPartyNeedGroups();
            this.loadNeeds();
        }
    }

    loadPartyNeedGroups () {
        partyNeedGroupsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyNeedGroupModel>([{field: "time", index: 1, order: "desc"}], [
            { field: "partyId", op: "eq", comparand: this.partyId }
        ]));
        this.subscribe(partyNeedGroupsStore, CrudReponse.GetAll).then((items: PartyNeedGroupModel[]) => {
           if (items.any()) {
               this.showGroupClick(items.first());
           }
        });
    }

    loadNeeds () {
        needsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<NeedModel>([{field: "position", index: 1, order: "asc"}]))
    }

    createRecords () {
        this.partyNeedGroup = {
            id: Guid.EmptyGuid(),
            partyId: this.partyId,
            time: moment().format("YYYY-MM-DDTHH:mm:ss"),
            tenantUserId: this.tenantUser.id
        } as PartyNeedGroupModel;
        this.partyNeeds = this.needs.map((e: NeedModel) => {
            return {
                id: Guid.EmptyGuid(),
                needId: e.id,
                need: e,
                description: "",
                createdAt: moment().format("YYYY-MM-DDTHH:mm:ss")
            } as PartyNeedModel;
        });
        this.editMode = true;
    }

    save () {
        if (this.form.validate()) {
            if (this.partyNeedGroup?.id == Guid.EmptyGuid()) {
                this.saving = true;
                this.partyNeedGroup!.partyNeeds = this.partyNeeds;
                partyNeedGroupsStore.dispatch(CrudAction.Create, { item: this.partyNeedGroup });
                this.subscribe(partyNeedGroupsStore, CrudReponse.Create).then((n: PartyNeedGroupModel) => {
                    this.saving = false;
                    this.loadPartyNeedGroups();
                    this.showGroupClick(n);
                    this.editMode = false;
                }).catch((e: any) => {
                    this.saving = false;
                    throw e;
                });
            }
            else {
                this.saving = true;
                this.partyNeedGroup!.partyNeeds = this.partyNeeds;
                partyNeedGroupsStore.dispatch(CrudAction.Update, { item: this.partyNeedGroup });
                this.subscribe(partyNeedGroupsStore, CrudReponse.Update).then((n: PartyNeedGroupModel) => {
                    this.saving = false;
                    this.loadPartyNeedGroups();
                    this.showGroupClick(n);
                    this.editMode = false;
                }).catch((e: any) => {
                    this.saving = false;
                    throw e;
                });
            }
        }
    }

    showGroupClick (item: PartyNeedGroupModel | null) {
        if (item) {
            this.partyNeedGroup = {...item};
            this.partyNeeds = this.partyNeedGroup.partyNeeds!.sort((a: PartyNeedModel, b: PartyNeedModel) => {
                return a.need!.position! - b.need!.position!;
            });
        }
        else {
            this.partyNeedGroup = null;
            this.partyNeeds = [];
        }
        this.editMode = false;
    }

    deleteItemClick (item: PartyNeedGroupModel) {
        this.deleteDialog = true;
        this.itemToDelete = item;
    }

    deleteItem () {
        this.deleting = true;
        partyNeedGroupsStore.dispatch(CrudAction.Delete, { id: this.itemToDelete!.id });
        this.subscribe(partyNeedGroupsStore, CrudReponse.Delete).then((e: any) => {
            if (this.itemToDelete!.id == this.partyNeedGroup?.id) {
                this.partyNeedGroup = null;
                this.partyNeeds = [];
                this.editMode = false;
            }
            this.deleting = false;
            this.deleteDialog = false;
            this.itemToDelete = null;
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

    abandon () {
        this.editMode = false;
        if (this.partyNeedGroup?.id == Guid.EmptyGuid()) {
            this.partyNeedGroup = null;
            this.partyNeeds = [];
        }
        else {
            this.showGroupClick(this.partyNeedGroups.find((x: PartyNeedModel) => x.id == this.partyNeedGroup?.id)!);
        }
    }

    printClick () {
        partyNeedGroupsStore.dispatch(CrudAction.Print, { id: this.partyNeedGroup!.id! });
    }

}
